module.exports = __webpack_public_path__ + "static/img/r-1-4-icon.eb34e25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-1/r-1-4-icon.png
// module id = Zpc7
// module chunks = 0